import { useDispatch, useSelector } from 'react-redux';
import { ThemeContext } from 'styled-components';
import React, { useContext } from 'react';
import { changeStep } from 'store/modules';
import { StepContentWrapper } from 'components';
import { withWizard } from 'containers';
import VehicleManager from './vehicleManager';
import QuantityOfTrackers from './quantityOfTrackers';
import QuantityTypes from './quantityTypes';
import CameraTypes from './cameraTypes';
import Blocker from './blocker';
import FinesManager from './fines';

export default function SolutionWizard({
  navigateBack: parentNavigateBack,
  navigateForward: parentNavigateForward,
  currentStep: parentCurrentStep,
}) {
  const theme = useContext(ThemeContext);
  const dispatch = useDispatch();
  const { solutionInfo } = useSelector((state) => state.subscription);
  
  const {
    vehicleManager,
    trackersBatch,
    quantityTypes,
    cameraTypes,
    blocker,
    finesManager,
  } = solutionInfo || {};

  const onCancel = () => {
    parentNavigateBack();
  };

  const navigateBackOnCancel = ({ navigateBack }) => () => {
    navigateBack();
  };

  const onCompleted = (values) => {
    parentNavigateForward(values);
  };

  const onValuesChanged = (props) => {
    const { values, currentStep } = props;
    if (values) {
      const { 
        quantityTypes: resetQuantityTypes,
        cameraTypes: resetCameraTypes,
        trackersBatch: resetTrackersBatch,
        blocker: resetBlocker,
        ...formData
      } = values.formValues[values.childStep];
      
      dispatch(
        changeStep({
          step: 'solutionInfo',
          currentStep,
          parentCurrentStep,
          [values.childStep]: formData,
          ...(resetQuantityTypes === null && { quantityTypes: null }),
          ...(resetCameraTypes === null && { cameraTypes: null }),
          ...(resetTrackersBatch === null && { trackersBatch: null }),
          ...(resetBlocker === null && { blocker: null }),
        }),
      );
    }
  };

  function onSubmit({ navigateForward, childStep }) {
    return (values) => navigateForward({ childStep, formValues: values });
  }

  const steps = [
    {
      content: (props) => (
        <VehicleManager
          {...props}
          initialValues={{ vehicleManager, quantityTypes, cameraTypes }}
          onCancel={onCancel}
          onSubmit={onSubmit({ ...props, childStep: 'vehicleManager' })}
        />
      ),
    },
    {
      content: (props) => (
        <QuantityOfTrackers
          {...props}
          initialValues={{ ...trackersBatch, vehicleManager }}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'trackersBatch' })}
        />
      ),
    },
    {
      content: (props) => (
        <QuantityTypes
          {...props}
          initialValues={{ vehicleManager, quantityTypes }}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'quantityTypes' })}
        />
      ),
    },
    {
      content: (props) => (
        <CameraTypes
          {...props}
          initialValues={{ vehicleManager, cameraTypes }}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'cameraTypes' })}
        />
      ),
    },
    {
      content: (props) => (
        <Blocker
          {...props}
          initialValues={{ blocker, vehicleManager, quantityTypes }}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'blocker' })}
        />
      ),
    },
    {
      content: (props) => (
        <FinesManager
          {...props}
          initialValues={finesManager}
          onCancel={navigateBackOnCancel(props)}
          onSubmit={onSubmit({ ...props, childStep: 'finesManager' })}
        />
      ),
    },
  ];

  return withWizard({
    steps,
    theme,
    onValuesChanged,
    onCompleted,
    parentCurrentStep,
  })(({ children }) => <StepContentWrapper>{children}</StepContentWrapper>);
}
